import { BoxPage } from '@/components/common/BoxPage'
import { useTranslator } from '@/hooks'
import { Typography } from '@mui/material'

const Voucher = () => {
  const { __ } = useTranslator()

  return (
    <BoxPage
      title={__('Voucher Management')}
      breadcrumbs={[{ label: __('Finance Management') }, { label: __('Voucher Management'), href: '/cms/finance/voucher' }]}
    >
      <div className='flex items-center flex-col text-center'>
        <div className='flex flex-col items-center justify-center gap-2 is-[90vw] sm:is-[unset] mbe-6 h-[150px]'>
          <Typography variant='h4'>
            {__('This Menu Is Not Available Yet 🔐')}
          </Typography>
          <Typography>{__('Please wait for the upcoming update.')}</Typography>
        </div>
        <div className='w-full max-h-[400px]'>
          <img
            alt='error-404-illustration'
            src='/images/illustrations/characters/notyet-image.png'
            className='object-contain w-full h-[600px]'
          />
        </div>
      </div>
    </BoxPage>
  )
}

export default Voucher
